import { Platform } from "react-native";

const API_VERSION = "/v1";

const AppConfig = {
  DISPLAY_VERSION: "31461",
  UPDATE_VERSION: "1", //codepush updates

  DEFAULT_THEME: "v3", // TODO: move to server

  MAX_WIDTH: Platform.OS === "web" ? 411 : 420,
  BORDER_RADIUS: 16,
  INPUT_COLOR: "#2D3142",
  MANA_PURPLE: "#9F47E9",
  NUM_OF_FAVORITES: 3,
  NUM_OF_ACTIVITIES: 5,
  NUM_OF_TAGS: 10,
  NUM_OF_SETS: 5,
  API_VERSION: API_VERSION,
  API_URL: "https://app.mana.ai:8888" + API_VERSION,

  BIAS_PREDICTIONS_WITH_SEQUENCES: true,

  ENABLE_SEGMENT: false,

  DISABLE_MOBILE_CAL: true,

  GOOGLE_CLIENT_OFFLINE: true,

  PACK_STATE: true,

  MIN_TIMESLOTS_SIZE: 15,
  CHUNKS_SIZE: 15,

  USE_DRAWER: true,
  USE_NAVIGATION: true,
  IS_PARTY_TIME: false,
  AUTOTRACKED: 3,
  AUTOREVIEW_UNCONFIRMED: 3,
  AUTOREVIEW_CONFIRMED: 4,

  COACHING_LINK: "https://mana.ai/pricing",
  CALENDLY_LINK: "https://calendar.app.google/1xx1n3mUZpGKPH4EA",
  GUIDANCE_LINK: "https://manaai.typeform.com/to/apTY43rY",
  WORK_BOUNDARIES_LINK: "https://mana.ai/blog/how-to-set-work-life-boundaries",
  AVOID_DISTRACTIONS_LINK: "https://mana.ai/blog/avoid-distractions",
  GOAL_SETTING_LINK: "https://mana.ai/blog/steps-to-set-goals",
  PRIVACY_LINK: "https://mana.zendesk.com/hc/en-us/sections/4408636799508-Privacy",
  MAC_DOWNLOAD_URL: "https://app.mana.ai/kits/Mana.pkg",
  WIN_DOWNLOAD_URL: "https://app.mana.ai/kits/Mana.exe",
  CHROME_DOWNLOAD_URL: "https://app.mana.ai/kits/mana-chrome.zip",
  SLACK_DOWNLOAD_URL: "https://int.mana.ai:3002/slack/install",
  STRIPE_URL: "https://buy.stripe.com/fZe6pRa4J2O64Te6oy",

  API_KEY: "6cb848aeaa0d42c4afac37fd6d5e6d7b",
  SECRET: "dGVzdDEyMzQ=",

  SEGMENT_KEY: "V0zDKucgwdySmYQHqB7UCeCXFSVMWsHI",
};

export default AppConfig;
